module.exports = __webpack_public_path__ + "static/media/san-marino.8119479a.svg";